import * as actionTypes from '../constants/index';
const setProjectInfo = data => {
	return {
		type: actionTypes.SET_PROJECTINFO,
		data
	};
};

export { setProjectInfo };
